import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {Form, Formik, Field, ErrorMessage} from 'formik';
import {PasswordField} from './PasswordField';
import {Messages} from '../../layout/Messages/Messages';

function NewPasswordForm(props) {
  const {onSubmit, schema, initialValues, btnId} = props;

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        validateOnChange={false}
        enableReinitialize={true}
        onSubmit={
          values => {
            onSubmit(values);
          }
        }
      >
        {props => (
          <Fragment>
            <Messages
              color="danger"
              formikProps={props}
            >
              <ErrorMessage name="password" component="div"
                            data-testid="errors-password"
                            className="field-error"/>
              <ErrorMessage name="password_confirmation" component="div"
                            data-testid="errors-password_confirmation"
                            className="field-error"/>
              <ErrorMessage name="token" component="div"
                            data-testid="errors-token" className="field-error"/>
            </Messages>
            <Form>
              <PasswordField handleBlur={props.handleBlur}/>
              <PasswordField name="password_confirmation"
                             handleBlur={props.handleBlur}/>
              <Field
                type="hidden"
                name="token"
              />
              <div className="text-center">
                <FormattedMessage id={btnId}>
                  {
                    valueBtn => <Field name="submit"
                                       className="my-4 btn btn-info"
                                       color="info" type="submit"
                                       value={valueBtn}/>
                  }
                </FormattedMessage>
              </div>
            </Form>
          </Fragment>
        )}
      </Formik>
    </Fragment>
  );
}

NewPasswordForm.defaultProps = {
  showVerificationCode: false,
  onSubmit: () => {
  },
  schema: {}
};

export {NewPasswordForm};
